/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Focus_WindowInputs */



/**
* | output |
* | --- |
* | "Bring the window to the front" |
*
* @param {Artifact_Focus_WindowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_focus_window = /** @type {((inputs?: Artifact_Focus_WindowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Focus_WindowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fenster in den Vordergrund holen")
	return /** @type {LocalizedString} */ ("Bring the window to the front")
});